import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// react-bootstrap
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import InputGroup from 'react-bootstrap/InputGroup';
import Stack from 'react-bootstrap/Stack';
import Alert from 'react-bootstrap/Alert';

// third-party
import { useForm } from 'react-hook-form';

// project-imports
import MainCard from 'components/MainCard';

import { apiFetch } from '../../services/api';

// assets
import DarkLogo from 'assets/images/PRODUCION_SOS_VER.png';

// ==============================|| AUTH LOGIN FORM ||============================== //

export default function AuthLoginForm({ className, link }) {
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      setErrorMsg('');

      const response = await apiFetch('/auth/login', {
        method: 'POST',
        body: JSON.stringify({
          email: data.email,
          password: data.password
        })
      });

      //  Log para diagnóstico - quítalo cuando todo funcione
      //console.log('RESPUESTA BACKEND LOGIN:', response);

      // Detectar token en cualquiera de las formas comunes
      const token =
        response.token ||
        response.access_token ||
        response.data?.token ||
        response.data?.access_token;

      // Detectar user en cualquiera de las formas comunes
      const user =
        response.user ||
        response.data?.user ||
        response.usuario ||
        response.data?.usuario;

      if (!token) {
        throw new Error('No se recibió un token de acceso del servidor.');
      }

      // Guardar token SIEMPRE
      localStorage.setItem('token', token);

      // Guardar user SIEMPRE (aunque venga vacío, para no romper)
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
       // console.log(' USER guardado en localStorage:', user);
      } else {
        //console.warn(' El backend no devolvió user. Estructura recibida:', response);
        // Fallback: intentar decodificar el JWT para sacar el user
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          //console.log(' JWT payload:', payload);
          const userFromJwt = payload.user || payload;
          if (userFromJwt) {
            localStorage.setItem('user', JSON.stringify(userFromJwt));
         //   console.log(' USER extraído del JWT:', userFromJwt);
          }
        } catch (e) {
          //console.warn('No se pudo decodificar el JWT:', e);
        }
      }

      navigate('/', { replace: true });
      window.location.reload();
    } catch (error) {
      setErrorMsg(error.message || 'Credenciales inválidas o error al conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainCard className="mb-0">
      <div className="text-center mb-3">
        <a>
          <Image src={DarkLogo} alt="Logo de Producción SOS" fluid />
        </a>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <h4 className={`text-center f-w-500 mt-2 mb-3 ${className}`}>Iniciar Sesión</h4>

        {errorMsg && <Alert variant="danger" className="py-2 small">{errorMsg}</Alert>}

        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Control
            type="email"
            placeholder="Correo Electrónico"
            {...register('email')}
            isInvalid={!!errors.email}
            className={className && 'bg-transparent border-white text-white border-opacity-25 '}
          />
          <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formPassword">
          <InputGroup>
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              placeholder="Contraseña"
              {...register('password')}
              isInvalid={!!errors.password}
              className={className && 'bg-transparent border-white text-white border-opacity-25 '}
            />
            <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
              {showPassword ? <i className="ti ti-eye" /> : <i className="ti ti-eye-off" />}
            </Button>
            <Form.Control.Feedback type="invalid">{errors.password?.message}</Form.Control.Feedback>
          </InputGroup>
        </Form.Group>

        <Stack direction="horizontal" className="mt-1 justify-content-between align-items-center">
          <Form.Group controlId="customCheckc1">
            <Form.Check
              type="checkbox"
              label="¿Recordarme?"
              defaultChecked
              className={`input-primary ${className ? className : 'text-muted'} `}
            />
          </Form.Group>
          
        </Stack>

        <div className="text-center mt-4">
          <Button type="submit" className="shadow px-sm-4 w-100" disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </Button>
        </div>

      
      </Form>
    </MainCard>
  );
}

AuthLoginForm.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string
};